import {  inscriptionsService } from '../_services';
const insServ = inscriptionsService;

const state = {

};

const actions = {

  stInscriptionsAll({commit}) {
    return new Promise((resolve, reject) => {
      insServ.srvInscriptionsAll().then( res => {

        return resolve(res.data);

      });

    });
  }

};

const mutations = {

};

const getters = {

}

export const inscriptions = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
};
